import { Alert } from '../UI/Alert'
import { Button } from '../UI/Button'
import { formLabelClass, Textarea } from '../UI/Form'

export type OfferAiInstructionPanelProps = {
  aiInstruction: string
  onAiInstructionChange: (value: string) => void
  onGenerate?: () => void
  onRegenerate?: () => void
  isBusy: boolean
  canGenerate: boolean
  canRegenerate: boolean
  error?: string | null
  showGenerate?: boolean
  instructionId?: string
}

export function OfferAiInstructionPanel({
  aiInstruction,
  onAiInstructionChange,
  onGenerate,
  onRegenerate,
  isBusy,
  canGenerate,
  canRegenerate,
  error,
  showGenerate = true,
  instructionId = 'offer-ai-instruction',
}: OfferAiInstructionPanelProps) {
  return (
    <div className="flex flex-col gap-3">
      <label htmlFor={instructionId} className={formLabelClass}>
        Οδηγία για το AI{' '}
        <span className="font-normal text-zinc-500">(προαιρετικό)</span>
      </label>
      <Textarea
        id={instructionId}
        value={aiInstruction}
        onChange={(e) => onAiInstructionChange(e.target.value)}
        rows={3}
        placeholder="π.χ. Κάν’ το πιο σύντομο, πρόσθεσε εγγύηση 2 ετών, αφαίρεσε την ενότητα υλικών"
        className="resize-y text-sm leading-relaxed"
        disabled={isBusy}
      />
      <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap">
        {showGenerate && onGenerate && (
          <Button
            type="button"
            size="lg"
            onClick={onGenerate}
            disabled={!canGenerate || isBusy}
          >
            {isBusy && canGenerate ? 'Γίνεται επεξεργασία…' : 'Δημιουργία με AI'}
          </Button>
        )}
        {onRegenerate && (
          <Button
            type="button"
            variant="secondary"
            size="lg"
            onClick={onRegenerate}
            disabled={!canRegenerate || isBusy}
          >
            {isBusy && canRegenerate
              ? 'Επαναδημιουργία…'
              : 'Επαναδημιουργία με AI'}
          </Button>
        )}
      </div>
      {error ? (
        <Alert tone="error" className="text-left">
          {error}
        </Alert>
      ) : null}
    </div>
  )
}
